export default __webpack_public_path__ + "locales/ru/OAuth.json?hash=f685df440f18510e1ddb91261ea58f50";